import { createRoot } from 'react-dom/client';

// style.scss
import './assets/style.css';

// scroll bar
import 'simplebar-react/dist/simplebar.min.css';

// apex-chart
import 'assets/third-party/apex-chart.css';
import 'assets/third-party/react-table.css';

import '@fontsource-variable/inter';

import { Provider as ReduxProvider } from 'react-redux';

// project imports
import App from './App';
import { ConfigProvider } from 'contexts/ConfigContext';
import reportWebVitals from './reportWebVitals';
import { store } from './Redux/store';
import { injectStore } from './Redux/api/axiosInstance';
import { captureReferral } from './utils/referral';

// a friend's invite link (?ref=CODE) is remembered until the first sign-in
captureReferral();
injectStore(store);
import { StrictMode } from 'react';
import { Toaster } from 'sonner';
const container = document.getElementById('root');
const root = createRoot(container);

// ==============================|| MAIN - REACT DOM RENDER ||============================== //

root.render(
  <StrictMode>
    <ReduxProvider store={store}>
      <ConfigProvider>
        <App />
        <Toaster
          richColors
          position="top-right"
          toastOptions={{
            className: 'custom-toast-font'
          }}
        />
      </ConfigProvider>
    </ReduxProvider>
  </StrictMode>
);

reportWebVitals();
